// extracted by mini-css-extract-plugin
export default {"container":"Partners_container__cL-eE","title":"Partners_title__XaLtY","grid":"Partners_grid__Mexbf","item":"Partners_item__q4Q78"};